import { useRef } from "react";
import { useTranslation, Trans } from "react-i18next";
import { Link } from "react-router-dom";

import NavBar from "../components/NavBar";
import BackgroundImage from "../components/BackgroundImage";
import TransLink from "../components/TransLink";
import Footer from "../components/Footer";


import {scrollCarousel} from "../utils/scrollCarousel"
import { trackCTA } from "../utils/eventTracker";

import {projects, reviews} from "../constants/portfolio"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import DottedLine  from "../components/DottedLine";
import {
faCheck,
faMagicWandSparkles,
faRocket,
faBrain,
faHandshake,
faPhone,
faGear,
faTruckFast,
faChartLine,
faMobileScreen,
faLightbulb,
faHammer,
faWrench,
faMicrochip,
faDatabase,
faEarthAmericas,
} from "@fortawesome/free-solid-svg-icons";



/*const iconMap = {
  faMagnifyingGlass,
  faGlobe,
  faTrophy,
  faThumbsUp,
  faEye,
  faBolt,
  faCode,
  faPaperPlane,
  faWifi,
  faSliders,
  faEarthAmericas,
  faChartSimple,
  faPhoneVolume,
  faDatabase,
  faNetworkWired,
  faAward,
  faShip,
  faMicrochip,
  faWrench,
  faHammer,
  faRobot,
  faCrown,
  faRoute,
  faLightbulb,
  faWarehouse,
  faKeyboard,
  faSatelliteDish,
  faRss,
  faMobileScreen,
  faMap,
  faListCheck,
  faHatWizard,
  faDisplay,
  faChartLine,
  faRoad,
  faBrain,
  faTruckFast,
  faPhone,
  faGear,
  faWandMagicSparkles,
  faHandshake,
  faRocket,
};


 function IconDump() {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "24px",
        padding: "20px",
        fontSize: "24px",
      }}
    >
      {Object.entries(iconMap).map(([name, icon]) => (
        <div key={name} className="dot milestone">
          <FontAwesomeIcon icon={icon} />
          <span
            style={{
              fontSize: "10px",
              marginTop: "6px",
              textAlign: "center",
              display: "block",
            }}
          >            
          </span>
        </div>
      ))}
    </div>
  );
}*/


export default function Hero() {

  const { t } = useTranslation();  
  const projectCarouselRef = useRef();
  const reviewCarouselRef = useRef();
  
  return (
    <>
      {/* Hidden SEO-friendly heading */}
      <h1 style={{ display: "none" }}>
        Custom App Development and Embedded Systems for IoT and Mobile
      </h1>
      {/* ABOVE THE FOLD */}      
      <section className="above-the-fold-wrapper">  
      <BackgroundImage/>               
      <NavBar/>         
      <div className="above-the-fold-layout">
        <div className="above-the-fold-left-wrapper">
          <div className="social-proof-pill">
            <img 
              src="/images/upwork_jss.webp" 
              alt="Upwork 100% Job Success" 
              className="upwork-icon"               
            />
            <span style={{textAlign:"center"}}>100% Upwork Job Success Score <br/> 20+ projects with 5⭐ reviews</span>
          </div>
          {/* Headline: Dream outcome and 'what's in it for me' */}
          <div className="you-will-read-this-first neon-glow">
            <Trans i18nKey="headline"/>
          </div>
          {/* Subheadline: "Stop doing X" | "No more Y" | "PainPoint". Our solution does X, Y, Z <br/>
            (articulate main benefit you provice & explain how you do what you <br/>
            mentioned in the headline ina propietary or unique way).*/}
          <div className="you-will-read-this-third">
            <Trans i18nKey={"subHeadline"}/>
           </div>
       <div className="cta-button-container center">
        <Link 
            to="/quote"
            className="cta-button"
            onClick={() => trackCTA("aboveTheFold")}
          >
            {/*MAIN ACTION TO TAKE */}            
            {t("ctaAboveTheFold")}
          </Link>
          </div>
          <div className = "above-the-fold-cta-text">
            {/*REDUCE Friction and FUDs (FEAR, UNCERTAINTY, DOUBTS)*/}
             <Trans
              i18nKey="reduceFUD"
              components={[
                <FontAwesomeIcon icon={faCheck} className="fa-icon" />,
                <br />
              ]}
            />
          </div>                  
        </div>

        <div className="above-the-fold-left-wrapper hide-in-mobile">
          <div className="above-the-fold-image-wrapper">
            <img src="/images/tech.webp" alt="Featured in" />
          </div>
        </div>
      </div>

      <div className="social-proof-banner">
        <div className="scrolling-logos">
          <img src="/projects/proof.webp" alt="Featured in" />
          <img src="/projects/proof.webp" alt="Featured in" />
          <img src="/projects/proof.webp" alt="Featured in" />
        </div>
      </div>
      </section>


      {/*UPWORK*/}
      <section className="section-block">
          <div className="section-image">
            <img 
            src="/images/section2.webp" 
              style={{
                filter: "brightness(2)"
              }}
            alt="Client reviews"
            loading="lazy" />
          </div>
        <div className="section-text-left">
          <div className="section-text">
            <h2 className="section-text-main">{t("testimonialsTitle")}</h2>
            <TransLink
              t="testimonialsParagraph"
              textStyle="section-text-secondary"
              linkStyle="section-link"
            />
          </div>
        </div>
      </section>
      <div className="testimonial-section">
        <div className="section-text-main">{t("testimonialSectionTitle")}</div>

        <div className="carousel-cards">
          <button className="carousel-arrow left" onClick={() => scrollCarousel("left", reviewCarouselRef)}>
            ‹
          </button>

          <div className="carousel-track" ref={reviewCarouselRef}>
            {reviews.map((review, index) => (
              <div className="card" key={index}>
                <h3 className="testimonial-title">{review.jobTitle}</h3>
                <div className="testimonial-stars">⭐⭐⭐⭐⭐</div>
                <p className="testimonial-text">"{review.text}"</p>
                <p className="testimonial-client">
                  {review.clientName}{" "}
                  <img
                    src={`https://flagcdn.com/64x48/${review.flag}.png`}
                    alt={`${review.flag.toUpperCase()} flag`}
                    className="flag-icon"
                    loading="lazy"
                  />
                </p>
              </div>
            ))}
            <div className="carousel-end-spacer" />
          </div>

          <button className="carousel-arrow right" onClick={() => scrollCarousel("right", reviewCarouselRef)}>
            ›
          </button>
        </div>

        <div className="cta-button-secondary-wrapper">
          <Link 
            to="/quote" 
            className="cta-button-secondary"
            onClick={() => trackCTA("testimonials")}
          >
            {t("ctaShareVision")}
          </Link>
        </div>
      </div>
      


      {/* SERVICES */}
      <div className="testimonial-section">
        <h2 className="section-title-centered neon-glow">{t("servicesSectionTitle")}</h2>        
        {/* PCB & FIRMWARE */}
        <section className="section-block">          
          <div className="services-block">
            <div className="service-image">
              <img src="/images/PCB&Firmware.webp" alt="PCB & Firmware" loading="lazy" className="box-glow"/>
            </div>         
            <div className="services-text-block card-box">
              <h2 className="section-text-main">{t("firmwareTitle")}</h2>
              <p className="section-text-secondary">
                <Trans i18nKey="firmwareParagraph" />
              </p>
            </div>
          </div>     
        </section>
        {/* PCB & FIRMWARE CTA */}
        <div className="cta-button-secondary-wrapper">
          <Link
            to="/quote"
            className="cta-button-secondary"
            onClick={() => trackCTA("PCB&firmware")}  
          >
            {t("ctaBookCall")}
          </Link>
        </div>

        {/* WEB & MOBILE */}
        <section className="section-block">
          <div className="services-block">
            <div className="services-text-block card-box">
              <h2 className="section-text-main">{t("mobileTitle")}</h2>
              <p className="section-text-secondary">
                <Trans i18nKey="mobileParagraph" />
              </p>
            </div>

            <div className="service-image">
              <img src="/images/Mobile&Web.webp" alt="Mobile & Web" loading="lazy" className="box-glow"/>
            </div>         
          </div>     
        </section>
        {/* WEB & MOBILE CTA */}
        <div className="cta-button-secondary-wrapper">
          <Link
            to="/quote"
            className="cta-button-secondary"
            onClick={() => trackCTA("web&mobile")}  
          >
            {t("ctaContactMe")}
          </Link>
        </div>
      </div>


      {/* BACKEND & CLOUD */}
      <section className="section-block">
        <div className="services-block">
          <div className="service-image">
            <img src="/images/Backend&Cloud.webp" alt="Backend & Cloud" loading="lazy" className="box-glow"/>
          </div>     
          <div className="services-text-block card-box">
            <h2 className="section-text-main">{t("backendTitle")}</h2>
            <p className="section-text-secondary">
              <Trans i18nKey="backendParagraph" />
            </p>
          </div>

  
        </div>     
      </section>
      {/* CTA  BACKEND & CLOUD */}
      <div className="cta-button-secondary-wrapper">
        <Link
          to="/quote"
          className="cta-button-secondary"
          onClick={() => trackCTA("backend&Cloud")}  
        >
          {t("ctaTalkDetails")}
        </Link>
      </div>
      {/**/}      


      {/*NEUROSHARP*/}
      <section className="section-block">
          <div className="section-image">
            <img 
              src="/images/neurosharp-logo.webp"
              alt="NeuroSharp Logo" 
              style={{ opacity: 0.3 }}
              loading="lazy"
            />
          </div>
          <div className="section-text-left">
            <h2 className="section-text-main">{t("neuroTitle")}</h2>
            <div className="section-text-secondary">
              <Trans i18nKey="neruoParagraph"/>
            </div>
          </div>        
      </section>
      


      <div className="section-text-centered-wrapper">
        <div className="testimonial-section">
          <h2 className="section-text-main">{t("neuroVideoTitle")}</h2>

          <div className="video-container">
            <div
              className="testimonial-video-wrapper youtube-placeholder"
              onClick={(e) => {
                const wrapper = e.currentTarget
                const iframe = document.createElement("iframe")
                iframe.src = "https://www.youtube.com/embed/Tdqb9m7BsOo?autoplay=1&mute=1"
                iframe.title = "NeuroSharp Testimonial"
                iframe.allow =
                  "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                iframe.allowFullscreen = true
                wrapper.innerHTML = ""
                wrapper.appendChild(iframe)
              }}
            >
              <img
                src="https://img.youtube.com/vi/Tdqb9m7BsOo/sddefault.jpg"
                alt="NeuroSharp Testimonial"
              />
              <div className="play-button">▶</div>
            </div>
          </div>
          
          <TransLink 
            t="neuroCurious"
            textStyle="section-text-secondary"
            linkStyle="project-link"
          />


          <div className="store-badges-container">
            <a
              href="https://play.google.com/store/apps/details?id=com.vallejoyuridamian.neurosharp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/assets/badges/google-play-badge.png"
                alt="Get it on Google Play"
                className="store-badge"
                loading="lazy"
              />
            </a>
            <a
              href="https://apps.apple.com/uy/app/neurosharp/id6749867627"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/assets/badges/app-store-badge.svg"
                alt="Download on the App Store"
                className="store-badge"
                loading="lazy"
              />
            </a>
          </div>
        </div>
      </div>
      <div className="cta-button-secondary-wrapper">
        <Link 
          to="/quote" 
          className="cta-button-secondary"
          onClick={() => trackCTA("neuro")}
        >
          {t("ctaMakeItHappen")}
        </Link>
      </div>
      {/**/}

      {/* ROADMAP */}
      <section className="section-block column">
        <div className="section-text-centered-wrapper">
          <div className="section-title-centered neon-glow">
            A CLEAR PATH FORWARD
          </div>
          <div className="section-subtitle-centered cyan">
            FROM IDEA TO LAUNCH
          </div>
          <p className="section-text-secondary max-w-3xl mx-auto">
            I have a straightforward defined process so you can know what to
            expect at every point of the project. I offer a clean, structured
            and transparent roadmap so we can have both piece of mind and
            alignment throughout our collaboration.
            
          </p>
        </div>

        <div className="roadmap-grid">
         <DottedLine
            totalDots={45}
            iconMap={{
            /* Discovery & Alignment */
            2: { icon: faLightbulb },
            4: { icon: faPhone },            
            6: { icon: faHandshake },
            /* Design & Prototype */
            11: { icon: faBrain },
            13: { icon: faGear },            
            15: { icon: faMagicWandSparkles },
            /* Build & Iterate */
            20: { icon: faHammer },
            22: { icon: faMicrochip },
            24: { icon: faMobileScreen },
            /* Launch & Scale */
            29: { icon: faRocket },
            31: { icon: faEarthAmericas },
            33: { icon: faTruckFast },
            /* Ongoing Support */
            38: { icon: faWrench },
            40: { icon: faDatabase },
            42: { icon: faChartLine },
       
            }}
          />
          <div className="empty-space"></div>
          <div className="roadmap-card half-box push-right card-box equal-height-5">
            <div className="section-text-main">Discovery & Alignment</div>
            <p className="section-text-secondary">
            Once you submit the contact form, I’ll reach out within 24 hours to schedule a call so you can walk me through your idea, objectives, and constraints.
            Based on the outcome of our conversation, I will provide you with a clear,
            written quotation which covers scope, costs, timeline and technical details of
            my offer. 
            This part of the process is free of cost for you and it can be revised
            both at this or future stages.
              
            </p>
          </div>

          <div className="roadmap-card half-box push-left card-box equal-height-5">
            <div className="section-text-main">Design & Prototype</div>
            <p className="section-text-secondary">
              Once we have an agreement, I start with the development.
              The goal here is to deliver a working prototype. A PoC, MVP, or early version of the product that can be tested and evaluated. It could be a mobile app bundle, firmware on off-the-shelf hardware, or a small production run of custom PCBs. We'll have regular check-ins to track progress and make adjustments.
            </p>
          </div>

          <div className="roadmap-card half-box push-right card-box equal-height-5">
            <div className="section-text-main">Build & Iterate</div>
            <p className="section-text-secondary">
              After the prototype is validated, we move into the main build.
              This stage focuses on stability, performance, and completeness. For apps, refined UI, smooth UX, and comprehensive testing. For hardware or firmware, that means optimization, robustness, and production readiness. Every part is finalized for real-world use.
            </p>
          </div>

          <div className="roadmap-card half-box push-left card-box equal-height-5">
            <div className="section-text-main">Launch & Scale</div>
            <p className="section-text-secondary">
              Once the product is ready, we handle the transition to production.
              That might include publishing to app stores, preparing for mass manufacturing, setting up infrastructure, creating a landing page, or launching an ad campaign.
              We adapt to your particular goals and make sure the product is ready for real users and real growth.             
            </p>
          </div>

          <div className="roadmap-card half-box push-right card-box equal-height-5">
            <div className="section-text-main">Ongoing Support</div>
            <p className="section-text-secondary">
              Support continues post-launch if required. I can provide maintenance, feature updates, performance improvements, infrastructure scaling, and long-term versioning. Whether it’s occasional work or continuous development, I stay available for what comes next.
            </p>
          </div>
          <div className="bottom-space"></div>
        </div>
        
        
        <div className="cta-button-secondary-wrapper">
          <Link
            to="/quote"
            className="cta-button-secondary"
            onClick={() => trackCTA("roadmap")}
          >
            {t("ctaBookCall")}
          </Link>
        </div>
        
        
      </section>
      {/**/}

      {/*
      // TECH STACK 
      <section className="section-layout">
        <h2 className="section-title-centered">{t("myTechStack")}</h2>
        <p className="section-text-secondary">{t("myTechStackSubtitle")}</p>
      </section>

      <div className="carousel-cards">
        <button className="carousel-arrow left" onClick={() => scrollCarousel("left", carouselRef)}>
          ‹
        </button>
        <div className="carousel-track" ref={carouselRef}>
          <div className="card">
            <img src="/logos/c.png" alt="C/C++" className="tech-icon" loading="lazy"/>
            <h3 className="card-title">{t("cardFirmwareTitle")}</h3>
            <p className="card-description">{t("cardFirmwareText")}</p>
          </div>
          <div className="card">
            <img src="/logos/react.png" alt="React Native" className="tech-icon" loading="lazy"/>
            <h3 className="card-title">{t("cardMobileTitle")}</h3>
            <p className="card-description">{t("cardMobileText")}</p>
          </div>
          <div className="card">
            <img src="/logos/backend.png" alt="Firebase" className="tech-icon" loading="lazy"/>
            <h3 className="card-title">{t("cardBackendTitle")}</h3>
            <p className="card-description">{t("cardBackendText")}</p>
          </div>
          <div className="card">
            <img src="/logos/pcb.png" alt="PCB Design" className="tech-icon" loading="lazy"/>
            <h3 className="card-title">{t("cardElectronicsTitle")}</h3>
            <p className="card-description">{t("cardElectronicsText")}</p>
          </div>
          <div className="card">
            <img src="/logos/fpga.png" alt="FPGA" className="tech-icon" loading="lazy"/>
            <h3 className="card-title">{t("cardFpgaTitle")}</h3>
            <p className="card-description">{t("cardFpgaText")}</p>
          </div>
          <div className="card">
            <img src="/logos/cloud.png" alt="AWS" className="tech-icon" loading="lazy"/>
            <h3 className="card-title">{t("cardCloudTitle")}</h3>
            <p className="card-description">{t("cardCloudText")}</p>
          </div>
          <div className="carousel-end-spacer" />
        </div>
        <button className="carousel-arrow right" onClick={() => scrollCarousel("right", carouselRef)}>
          ›
        </button>
      </div>
      */}

      {/* WHO I WORKED WITH */}
      <section className="section-layout margin">
        <h2 className="section-title-centered neon-glow">{t("whoIWorkedWithTitle")}</h2>
        <p className="section-text-secondary">{t("whoIWorkedWithSubtitle")}</p>
      </section>

      <div className="carousel-cards">
        <button className="carousel-arrow left" onClick={() => scrollCarousel("left", projectCarouselRef)}>
          ‹
        </button>
        <div className="carousel-track" ref={projectCarouselRef}>
          {projects.map((project) => (
            <Link to={project.route} key={project.title} className="card-link">
              <div className="card">
                <img src={project.image} alt={project.title} className="tech-icon-gradient" loading="lazy"/>
                <h3 className="card-title">{t(project.title)}</h3>
                <p className="card-description">{t(project.description)}</p>
              </div>
            </Link>
          ))}
          <div className="carousel-end-spacer" />
        </div>
        <button className="carousel-arrow right" onClick={() => scrollCarousel("right", projectCarouselRef)}>
          ›
        </button>
      </div>
    <Footer />
    </>
  );
}
